import { ProfileItem } from "PFApp/components/profile_item";
import { Select, SelectCommonProps } from "PFComponents/select";
import { fetchProfilesOptions } from "PFCore/services/profile";
import { BasicProfile, Id } from "PFCore/types";
import { Option } from "PFTypes/options";

type AssigneeSelectorProps = Omit<
  SelectCommonProps<BasicProfile>,
  "onChange" | "onClear" | "renderDisplayValue"
> & {
  value?: Id;
  onChange: (value: Id | null) => void;
};

export const AssigneeSelector = ({
  value,
  onChange,
  required,
  ref,
  ...selectProps
}: AssigneeSelectorProps) => (
  <Select<BasicProfile>
    inputRef={ref}
    dropdownWidth={300}
    {...selectProps}
    value={value}
    required={required}
    fetchOptions={async ({ searchTerm, ids }) => {
      const result = await fetchProfilesOptions({
        term: searchTerm,
        policyName: "resourcer",
        profileVisibility: "active",
        value: ids
      });
      const entries = result.entries.map((item) => ({
        id: item.id,
        displayElement: <ProfileItem profile={item} />,
        value: item.text,
        original: item
      }));
      return { entries, meta: { total: entries.length } };
    }}
    onChange={(value: Option<BasicProfile>) => onChange(value.original.id)}
    onClear={!required && value ? () => onChange(null) : undefined}
    renderDisplayValue={(option: Option<BasicProfile>) =>
      option?.original ? <ProfileItem profile={option.original} splitInfo /> : null
    }
  />
);
